import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';
import { fas } from '@fortawesome/free-solid-svg-icons';

const UserForm = () => {
    const [companyOptions, setCompanyOptions] = useState(null); //Utilizado para controlar quais as options da dropdownlist de Supplier
    const [groupOptions, setGroupOptions] = useState(null); //Utilizado para controlar quais as options da dropdownlist de Supplier
    const [companyOptionsAux, setCompanyOptionsAux] = useState(null); //Utilizado para guardar a lista inicial de Suppliers
    const [rolesOptions, setRolesOptions] = useState(null);
    const [cultureOptions, setCultureOptions] = useState(null);



    const handleUserRoleChange = (form, event) => {
        const roleSelect = event?.target?.value ?? form?.getFieldRef?.('roleID')?.current?.value;
        const companyRef = form?.getFieldRef?.('companyID')?.current;
        const groupRef = form?.getFieldRef?.('groupID')?.current;
        const needReadConsentRef = form?.getFieldRef?.('needReadConsent')?.current;
        if (roleSelect === undefined) return;

        if (roleSelect === "23D9D409-D7AA-4966-9047-48C04B41F0A1") { //Admin
            if (companyRef) { companyRef.disabled = true; companyRef.value = ""; }
            if (groupRef) { groupRef.disabled = true; groupRef.value = ""; }
            if (needReadConsentRef) needReadConsentRef.disabled = true;
        }
        else if (roleSelect === "198E176A-E8F5-437C-B6B9-AAB5972099F4") { //Approver
            if (needReadConsentRef) needReadConsentRef.disabled = false;
            if (companyRef) companyRef.disabled = false;
            if (groupRef) groupRef.disabled = false;
        }
        else {
            if (roleSelect === "BA6C43EB-7334-463B-B5CB-D712BD29339D") { //Info Holder
                setCompanyOptions(companyOptions.filter(x => x.value !== ""));
                if (groupRef) { groupRef.disabled = true; groupRef.value = ""; }
                if (companyRef) companyRef.value = "";
                if (needReadConsentRef) needReadConsentRef.disabled = true;
            } else {
                setCompanyOptions(companyOptionsAux);
                if (companyRef) companyRef.value = "";
                if (groupRef) { groupRef.disabled = true; groupRef.value = ""; }
                if (needReadConsentRef) needReadConsentRef.disabled = true;
            }
            if (companyRef) companyRef.disabled = false;
            if (groupRef) groupRef.disabled = false;
            if (needReadConsentRef) needReadConsentRef.disabled = true;
        }
    };

    const fields = [
        {
            label: "Username",
            name: "userName",
            type: "input"
        },
        {
            label: "First Name",
            name: "firstName",
            type: "input"
        },
        {
            label: "Last Name",
            name: "lastName",
            type: "input"
        },
        {
            label: "Email",
            name: "email",
            type: "input"
        },
        {
            label: "Password",
            name: "password",
            editable: false,
            type: "password"
        },
        {
            label: "Confirm Password",
            name: "confirmPassword",
            editable: false,
            type: "password"
        },
        {
            label: "Role",
            name: "roleID",
            type: "select",
            options: rolesOptions,
            onChanged: handleUserRoleChange,
        },
        {
            label: "Supplier",
            name: "companyID",
            type: "select",
            options: companyOptions,
            disabled: true,
            required: false,
        },
        {
            label: "Viewer Group",
            name: "groupID",
            type: "select",
            options: groupOptions,
            disabled: true,
            required: false,
        },
        {
            label: "Crop",
            name: "culture",
            type: "select",
            options: cultureOptions,
            disabled: false,
            required: false,
            multiple: true,
        },
        {
            label: "Need Read and Agree Consent?",
            name: "needReadConsent",
            type: "check",
            disabled: true,
            required: false,
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "check",
            disabled: false,
            required: false,
        },
        {
            label: "Is Internal User",
            name: "isInternalUser",
            type: "check",
            disabled: false,
            required: false,
        }

    ]

    const loadData = async () => {
        Api.get('Company/getAll').then((result) => {
            if (result && result.data) {
                var companyOptions = result.data.response.map(item => ({ value: item.companyID, text: item.name }));

                companyOptions = [{ value: "", text: "Global" }, ...companyOptions];

                setCompanyOptions(companyOptions);
                setCompanyOptionsAux(companyOptions);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
        Api.get('User/getAllRoles').then((result) => {
            if (result && result.data) {
                const rolesOptions = result.data.response.map(item => ({ value: item.id, text: item.name }));

                setRolesOptions(rolesOptions);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
        Api.get('Group/getAllGroups').then((result) => {
            if (result && result.data) {
                var groupsOptions = result.data.response.map(item => ({ value: item.groupID, text: item.name }));

                groupsOptions = [{ value: "", text: "All/NoGroup" }, ...groupsOptions];

                setGroupOptions(groupsOptions);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });

        Api.get(`Culture/getAll`).then((result) => {
            if (result && result.data) {
                console.log(result.data)
                const cultureOpts = result.data.response.map(item => ({ value: item.cultureID, text: item.cultureDisplayName }));

                setCultureOptions(cultureOpts);
            }
        }).catch((error) => {
            console.log('Erro Crop: ', error);
            exceptionNotificationAPI(error);
        });
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        companyOptions != null && rolesOptions != null && groupOptions != null && cultureOptions != null ? <FormCrud formName={"user"} title={"User"} fields={fields} /> : <></>
    );
}

export default UserForm;
